export default __webpack_public_path__ + "static/media/hasaka.177a976e.jpg";